import { Select } from 'gu-ui-kit'
import React from 'react'
import { useSelector } from 'react-redux'

const renderSelect = ({
  input,
  meta,
  errorIcon = null,
  helperText = null,
  renderError = (error) => error,
  t = () => {},
  required: requiredProp,
  ...rest
}) => {
  const requiredFromSchema = useSelector(
    (state) => state['forms/meta']?.[meta?.form]?.[input.name] ?? false,
  )
  const required = requiredProp ?? requiredFromSchema
  const ErrorIcon = errorIcon && meta?.touched && meta?.error ? errorIcon : null
  const isDisabled = rest.disabled || meta?.submitting

  const select = (
    <Select
      {...input}
      {...rest}
      required={required}
      disabled={isDisabled}
      helperText={
        meta?.touched && meta?.error ? (
          <>
            {ErrorIcon}
            {t(renderError(meta?.error))}
          </>
        ) : (
          helperText
        )
      }
      error={!!(meta?.touched && meta?.error)}
    />
  )

  if (isDisabled) {
    return <div style={{ pointerEvents: 'none' }}>{select}</div>
  }

  return select
}

export default renderSelect
